import React from 'react';
import { PlusIcon } from '@heroicons/react/20/solid';

export default function EmptyState({ title, description, buttonText, onClickAction }) {
  return (
    <div className="text-center">
      <svg
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
        className="mx-auto size-12 text-gray-400"
      >
        <path
          d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          strokeWidth={2}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <h3 className="mt-2 text-sm font-semibold text-gray-900">{title}</h3>
      <p className="mt-1 text-sm text-gray-500">{description}</p>
      {/* <div className="mt-6">
        <button
          type="button"
          style={{
            padding: '8px 16px',
            fontSize: '14px',
            borderRadius: '4px',
            cursor: 'pointer',
            backgroundColor: '#007bff', // Default button blue
            color: 'white',
            border: '1px solid #007bff',
            display: 'inline-flex',
            alignItems: 'center',
          }}
          onClick={onClickAction}
        >
          <PlusIcon aria-hidden="true" style={{ marginRight: '8px', marginLeft: '-2px', height: '16px', width: '16px' }} />
          {buttonText}
        </button>
      </div> */}
    </div>
  );
}
